export default (perm, module) => {
  const permissions = JSON.parse(localStorage.getItem("permissions"));
  if (permissions) {
    return permissions.some(
      (p) => p.action_name === perm && p.module_name === module
    );
  }
  return false;
};
